import React from 'react';
import clsx from 'clsx';
import type { SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';

import EmptyFolderIcon from 'src/components/empty-page/EmptyFolderIcon';

import styles from 'src/components/empty-page/EmptyPage.module.css';

type Props = {
    sx?: SxProps;
    className?: string;
    children: React.ReactNode;
}

export default function EmptyPage({
    sx,
    className,
    children
}: Props) {
    return (
        <Box className={clsx(styles.outer, className)} sx={sx}>
            <div className={styles.inner}>
                <EmptyFolderIcon />

                {children}
            </div>
        </Box>
    );
}
